<template>
  <div class="relative inline-block text-left z-[999]">
    <div>
      <button 
        @click="toggleDropdown" 
        type="button" 
        class="inline-flex focus:outline-none justify-center w-full rounded-md border border-[#e6204b] shadow-sm px-2 md:px-4 py-1 md:py-2 bg-black text-sm font-medium text-white hover:bg-[#950C16] hover:text-black  focus:ring-offset-2" 
        id="options-menu">
        {{ currentLang === 'en' ? 'English' : 'Français' }}
        <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
        </svg>
      </button>
    </div>
    <transition name="fade">
      <div 
        v-if="dropdownOpen" 
        class="origin-top-right absolute right-0 mt-2 w-36 md:w-56 rounded-md shadow-lg bg-black ring-1 ring-red-500 ring-opacity-5">
        <div class="py-1" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
          <a 
            @click.prevent="switchLanguage('en')" 
            href="#" 
            class="block px-4 py-2 text-sm text-white hover:bg-[#e6204b] hover:text-black" 
            role="menuitem">
            English
          </a>
          <a 
            @click.prevent="switchLanguage('fr')" 
            href="#" 
            class="block px-4 py-2 text-sm text-white hover:bg-[#e6204b] hover:text-black" 
            role="menuitem">
            Français
          </a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'LanguageDropdown',
  data() {
    return {
      currentLang: this.$i18n.locale,
      dropdownOpen: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    switchLanguage(lang) {
      this.$i18n.locale = lang;
      this.currentLang = lang;
      localStorage.setItem('lang', lang); // 🔒 Persistance
      this.dropdownOpen = false;
    },
  },
  created() {
    const savedLang = localStorage.getItem('lang');
    if (savedLang && savedLang !== this.currentLang) {
      this.switchLanguage(savedLang); // 🔄 Charge la langue sauvegardée
    }
  }
};
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
